import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-157">
      <div className="max-w-4xl mx-auto text-center" data-id="element-158">
        {/* Logo */}
        <div className="text-[#39FF14] text-3xl font-black tracking-widest mb-8" data-id="element-159">
          🇧🇷 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-160">
          El próximo domingo podés seguir buscando material en Google.
        </h2>
        <p className="text-[#39FF14] text-2xl sm:text-3xl font-black mb-10" data-id="element-161">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a0d] border border-[#39FF14]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-162">
          <div className="p-4 bg-[#000d08] border-b border-[#39FF14]/30 text-center font-bold text-white" data-id="element-163">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-164">
            <div className="p-4 text-gray-400 text-sm" data-id="element-165">
              3 horas de planificación por semana × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#39FF14]/5 sm:border-l border-gray-800" data-id="element-166">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-167">
            <div className="p-4 text-gray-400 text-sm" data-id="element-168">
              Evaluaciones sin solucionario × 30 alumnos × 3 trimestres
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#39FF14]/5 sm:border-l border-gray-800" data-id="element-169">
              Sábados de corrección sin criterios claros
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-170">
            <div className="p-4 text-gray-400 text-sm" data-id="element-171">
              Material adaptado para NEE inventado en el momento
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#39FF14]/5 sm:border-l border-gray-800" data-id="element-172">
              Riesgo pedagógico + desgaste docente
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-173">
            <div className="p-4 text-gray-400 text-sm" data-id="element-174">
              Material de Portugal que confunde al alumno argentino
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#39FF14]/5 sm:border-l border-gray-800" data-id="element-175">
              Falsos amigos sin contexto = errores que se fijan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-176">
            <div className="p-4 text-gray-400 text-sm" data-id="element-177">
              Clases sin oralidad porque "da miedo" implementarla
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#39FF14]/5 sm:border-l border-gray-800" data-id="element-178">
              Alumnos que "saben gramática" pero no hablan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-179">
            <div className="p-4 text-gray-400 text-sm" data-id="element-180">
              Clases improvisadas que no enganchan
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#39FF14]/5 sm:border-l border-gray-800" data-id="element-181">
              Alumnos que se pierden y no vuelven al portugués
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-182">
          <p className="text-white font-bold mb-4" data-id="element-183">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-184" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-185">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-186">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-187">
          <div className="bg-[#0a0a0a] border border-[#39FF14]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-188">
            <div className="text-2xl mb-2" data-id="element-189">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-190">MEGAPACK PORTUGUÊS</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-191">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-192">
              <p className="text-[#39FF14] text-2xl font-black mb-4" data-id="element-193">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48097216168192:1" className="btn-green-pulse block bg-[#39FF14] text-black font-black py-4 rounded-lg hover:bg-[#76FF03] transition-colors text-sm" data-id="element-194">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d08] border-2 border-[#39FF14] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(57,255,20,0.2)] flex flex-col" data-id="element-195">
            <div className="text-2xl mb-2" data-id="element-196">🏆</div>
            <h3 className="text-[#39FF14] font-black mb-1" data-id="element-197">
              MEGAPACK + ADAPTACIONES ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-198">
              6 Tomos + 6 Bonos + Kit Adaptaciones Curriculares & Inclusión
            </p>
            <div className="mt-auto" data-id="element-199">
              <p className="text-[#39FF14] text-3xl font-black mb-4" data-id="element-200">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48135042203904:1" className="btn-green-pulse block bg-[#39FF14] text-black font-black py-4 rounded-lg hover:bg-[#76FF03] transition-colors text-sm" data-id="element-201">
                → QUIERO EL MEGAPACK + ADAPTACIONES
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-202">
          <span data-id="element-203">🔒 Pago 100% seguro</span>
          <span data-id="element-204">⚡ Acceso en 5 minutos</span>
          <span data-id="element-205">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-206">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}